// extracted by mini-css-extract-plugin
module.exports = {"usersTable":"UserManagement_usersTable__2w4jN","overflow":"UserManagement_overflow__2oZDn"};